import React, { useState } from "react";
import Modal from "../../ReusableComponents/Modal";
import Button from "./Button";
import { CANCELLEDREQUESTNOTES } from "../../appConstants";
export default function RequestCancelPopup({ open, onClose, onRequestUpdate }) {
  const [cancelReason, setCancelReason] = useState(undefined);
  const [otherReason, setOtherReason] = useState("");
  const [otherReasonError, setOtherReasonError] = useState("");

  const handleChange = (event) => {
    const value = event.target.value;
    setCancelReason(value);
    if (value !== "Other") {
      setOtherReason("");
      setOtherReasonError("");
    }
  };

  const handleOtherReasonChange = (e) => {
    const value = e.target.value;
    setOtherReason(value);

    const valid = /^[A-Za-z\s]{20,}$/;
    if (!valid.test(value)) {
      setOtherReasonError(
        "reason must be at least 20 characters and contain only letters and spaces."
      );
    } else if(value.length>200){
      setOtherReasonError("reason must be less than 200 characters");
    } else {
      setOtherReasonError("");
    }
  };

  const isSubmitDisabled =
    !cancelReason ||
    (cancelReason === "Other" &&
      (otherReason.trim() === "" || otherReasonError));

  return (
    <Modal
      header={"Cancel Request"}
      open={open}
      onClose={() => {
        setCancelReason(undefined);
        setOtherReason("");
        setOtherReasonError("");
        onClose();
      }}
      headerContainerStyle={{ padding: "15px 25px" }}
      contentStyle={{
        width: "670px",
        height: "auto",
        boxShadow: " 0px 1.02px 4.09px 6.14px rgba(118, 118, 118, 0.15)",
      }}
      divider={true}
      headingStyle={{ fontSize: "16px", fontWeight: 600 }}
      iconSize={"18px"}
    >
      <div className="flex flex-col justify-between">
        <div className="flex w-full justify-between py-2 px-8">
          <div className="w-full px-4 ">
            <h4 className="font-manrope font-[500] text-[16px] text-[#3B3B3B]">
              Select Resaon
            </h4>
            <div className="flex flex-col gap-[0.7rem] my-4">
              {[
                ...CANCELLEDREQUESTNOTES.map((note) => ({
                  label: note,
                  value: note,
                })),
                { label: "Other", value: "Other" },
              ].map((option) => (
                <div className="flex gap-2">
                  <input
                    className="cursor-pointer focus:outline-none "
                    type="radio"
                    name="options"
                    height={8}
                    width={10}
                    value={option.value}
                    checked={cancelReason === option.value}
                    onChange={handleChange}
                  />
                  <label key={option.value}>{option.label}</label>
                </div>
              ))}

              {cancelReason === "Other" && (
                <div>
                  <textarea
                    style={{
                      resize: "none",
                    }}
                    value={otherReason}
                    rows={3}
                    onChange={handleOtherReasonChange}
                    className="w-full placeholder:text-[14px] font-manrope font-[500] border border-[#BFC8D9] text-[#1E1E1E] text-[15px] rounded px-3 py-2 focus:outline-none max-h-[80px] "
                    placeholder="Enter your reason"
                  />
                  {otherReasonError && (
                    <p className="text-[#ef233c]  font-manrope font-[600] text-[13px]">
                      {otherReasonError}
                    </p>
                  )}
                </div>
              )}
            </div>
          </div>
        </div>
        <div className="flex ml-auto px-8 py-6 gap-6">
          <Button
            color={"#606571"}
            variant={"outlined"}
            title={"Not Now"}
            handleClick={onClose}
          />
          <Button
            color={"#0F5EFF"}
            isDisbaled={isSubmitDisabled}
            variant={"filled"}
            title={"Cancel"}
            hoverColor={"#1251D2"}
            handleClick={() => {
              onRequestUpdate(
                cancelReason === "Other" ? otherReason.trim() : cancelReason
              );
            }}
          />
        </div>
      </div>
    </Modal>
  );
}
